import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterBar = ({ onFiltersChange }) => {
  const [filters, setFilters] = useState({
    organization: '',
    lob: '',
    status: '',
    search: ''
  });

  const organizationOptions = [
    { value: '', label: 'All Organizations' },
    { value: 'enterprise-solutions', label: 'Enterprise Solutions Ltd' },
    { value: 'global-manufacturing', label: 'Global Manufacturing Corp' },
    { value: 'tech-innovations', label: 'Tech Innovations Inc' },
    { value: 'retail-dynamics', label: 'Retail Dynamics Group' }
  ];

  const lobOptions = [
    { value: '', label: 'All Lines of Business' },
    { value: 'OTC', label: 'Order to Cash (OTC)' },
    { value: 'P2P', label: 'Procure to Pay (P2P)' },
    { value: 'RTR', label: 'Record to Report (RTR)' },
    { value: 'Plan', label: 'Plan to Produce' },
    { value: 'EWM', label: 'Extended Warehouse Management' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'Active', label: 'Active' },
    { value: 'Planning', label: 'Planning' },
    { value: 'Review', label: 'Review' },
    { value: 'Completed', label: 'Completed' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      organization: '',
      lob: '',
      status: '',
      search: ''
    };
    setFilters(clearedFilters);
    onFiltersChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6 shadow-elevation-1">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Input
          type="search"
          placeholder="Search engagements..."
          value={filters?.search}
          onChange={(e) => handleFilterChange('search', e?.target?.value)}
        />
        
        <Select
          options={organizationOptions}
          value={filters?.organization}
          onChange={(value) => handleFilterChange('organization', value)}
          placeholder="Filter by organization"
        />
        
        <Select
          options={lobOptions}
          value={filters?.lob}
          onChange={(value) => handleFilterChange('lob', value)}
          placeholder="Filter by LoB"
        />
        
        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
          placeholder="Filter by status"
        />
      </div>
      {hasActiveFilters && (
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            Filters applied
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;